import {
  RESET_CONVERSATIONS,
  RESET_ERROR,
  RESET_USER_FILTER,
  GET_CONVERSATIONS,
  SET_CONVERSATIONS,
  GET_AGENTS,
  SET_AGENTS,
  GET_ACTIVITY,
  SET_ACTIVITY,
  GET_SKILLS,
  SET_SKILLS,
  GET_TABS_BY_SKILL,
  GET_CONVERSATIONS_FORM,
  SET_CONVERSATIONS_FORM,
  SET_CONVERSATIONS_FILTER,
  SET_GENERAL_FILTER,
  API_ERROR,
  GET_USER_FILTER,
  SET_USER_FILTER,
  UPDATE_USER_FILTER,
  UPDATE_USER_FILTER_SUCCESS,
  RESET_MANAGER_PANEL,
  HANDLE_LOGOUT_AGENT,
  HANDLE_LOGOUT_AGENT_SUCCESS,
  HANDLE_LOGOUT_AGENT_ERROR,
  HANDLE_LOGOUT_AGENT_CONFIRM,
  HANDLE_TRANSFER_CHATS_SUCCESS,
  GET_TABS_BY_SKILL_LOADING,
  GET_TABS_BY_SKILL_ERROR,
  GET_TABS_BY_SKILL_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorConversation: false,
  loadingConversation: false,
  dataConversation: null,
  successConversation: false,
  logoutAgentsStatus: {},
  idAgentLogoutOpen: null,
  tabs: [],
};

const Conversation = (state = initialState, action) => {
  switch (action.type) {
    case RESET_CONVERSATIONS:
      state = {
        ...state,
        errorConversation: false,
        loadingConversation: false,
        loadingConversationDelete: false,
        successConversation: false,
        dataConversation: null,
        dataConversationDelete: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorConversation: false,
        loadingConversation: false,
        loadingConversationEditCreate: false,
        loadingConversationActivate: false,
        successConversation: false,
        errorUserFilter: false,
        loadingUserUpdateFilter: false,
        successUserUpdate: false,
      };
      break;

    case RESET_USER_FILTER:
      state = {
        ...state,
        errorUserFilter: false,
        loadingUserUpdateFilter: false,
        successUserFilter: false,
      };
      break;

    case GET_CONVERSATIONS:
      state = {
        ...state,
        errorConversation: false,
        loadingConversation: true,
      };
      break;
    case SET_CONVERSATIONS:
      state = {
        ...state,
        errorConversation: false,
        loadingConversation: false,
        dataConversation: action.payload,
        conversationTime: Date.now(),
      };
      break;
    case GET_AGENTS:
      state = {
        ...state,
        errorAgent: false,
        loadingAgent: true,
      };
      break;
    case SET_AGENTS:
      state = {
        ...state,
        errorAgent: false,
        loadingAgent: false,
        dataAgent: action.payload,
      };
      break;
    case GET_ACTIVITY:
      state = {
        ...state,
        errorActivity: false,
        loadingActivity: true,
      };
      break;
    case SET_ACTIVITY:
      state = {
        ...state,
        errorActivity: false,
        loadingActivity: false,
        dataActivity: action.payload,
      };
      break;
    case GET_SKILLS:
      state = {
        ...state,
        errorSkills: false,
        loadingSkills: true,
      };
      break;
    case SET_SKILLS:
      state = {
        ...state,
        errorSkills: false,
        loadingSkills: false,
        dataSkills: action.payload,
      };
      break;
    case GET_TABS_BY_SKILL:
      state = {
        ...state,
        error: false,
        loadingTabs: false,
      };
      break;
    case GET_TABS_BY_SKILL_SUCCESS:
      state = {
        ...state,
        error: false,
        tabs: action?.payload?.data?.tabs,
        loadingTabs: false,
      };
      break;
    case GET_TABS_BY_SKILL_LOADING:
      state = {
        ...state,
        error: false,
        loadingTabs: true,
      };
      break;
    case GET_TABS_BY_SKILL_ERROR:
      state = {
        ...state,
        error: true,
        loadingTabs: false,
      };
      break;
    case GET_CONVERSATIONS_FORM:
      state = {
        ...state,
        errorConversation: false,
        loadingConversationForm: true,
        dataConversationForm: null,
      };
      break;
    case SET_CONVERSATIONS_FORM:
      state = {
        ...state,
        errorConversation: false,
        loadingConversationForm: false,
        dataConversationForm: action.payload,
      };
      break;
    case SET_CONVERSATIONS_FILTER:
      state = {
        ...state,
        dataConversationFilter: {
          ...state.dataConversationFilter,
          [action.payload.target]: action.payload.data,
        },
      };
      break;
    case SET_GENERAL_FILTER:
      state = {
        ...state,
        dataGeneralFilter: {
          ...state.dataGeneralFilter,
          ...action.payload.data,
        },
      };
      break;

    case GET_USER_FILTER:
      state = {
        ...state,
        errorUserFilter: false,
        loadingUserFilter: true,
        dataUserGetSetFilter: null,
      };
      break;

    case SET_USER_FILTER:
      state = {
        ...state,
        errorUserFilter: false,
        loadingUserFilter: false,
        dataUserGetSetFilter: action.payload,
      };
      break;

    case UPDATE_USER_FILTER:
      state = {
        ...state,
        errorUserFilter: false,
        loadingUserUpdateFilter: true,
        dataUserUpdateFilter: action.payload,
        successUserFilter: false,
      };
      break;
    case UPDATE_USER_FILTER_SUCCESS:
      state = {
        ...state,
        errorUserFilter: false,
        loadingUserUpdateFilter: false,
        dataUserUpdateFilter: action.payload,
        successUserFilter: true,
      };
      break;

    case API_ERROR:
      state = {
        ...state,
        errorConversation: action.payload,
        errorUserFilter: action.payload,
        loadingConversation: false,
        loadingConversationForm: false,
        successConversation: false,
        loadingUserFilter: false,
        loadingUserUpdateFilter: false,
        successUserFilter: false,
        loadingAgent: false,
        loadingActivity: false,
        loadingSkills: false,
      };
      break;

    case HANDLE_LOGOUT_AGENT: {
      const { idAgent } = action.payload;
      return {
        ...state,
        logoutAgentsStatus: {
          ...state.logoutAgentsStatus,
          [idAgent]: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    }

    case HANDLE_LOGOUT_AGENT_SUCCESS: {
      const { idAgent } = action.payload;
      return {
        ...state,
        idAgentLogoutOpen: null,
        logoutAgentsStatus: {
          ...state.logoutAgentsStatus,
          status: {
            success: new Date().getTime(),
          },
          [idAgent]: {
            loading: false,
            error: false,
            success: true,
          },
        },
      };
    }
    
    case HANDLE_LOGOUT_AGENT_ERROR: {
      const { idAgent, error } = action.payload;

      return {
        ...state,
        logoutAgentsStatus: {
          ...state.logoutAgentsStatus,
          [idAgent]: {
            loading: false,
            error: error,
            success: false,
          },
        },
      };
    }

    case HANDLE_LOGOUT_AGENT_CONFIRM: {
      const { idAgent } = action.payload;
      return {
        ...state,
        idAgentLogoutOpen: idAgent,
      };
    }

    case RESET_MANAGER_PANEL:
      state = { ...initialState };
      break;

    default:
      // state = { ...state, errorConversation: false, loadingConversation: false };
      break;
  }
  return state;
};

export default Conversation;
